import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import QRCode from 'qrcode';

function ExpiredModal({ show, extendTicketUrl, onHide }) {
  const [qrCodeUrl, setQrCodeUrl] = useState('');

  useEffect(() => {
    setQrCodeUrl('');
    if (!extendTicketUrl) return undefined;

    let cancelled = false;
    QRCode.toDataURL(extendTicketUrl, {
      errorCorrectionLevel: 'H',
      margin: 1,
      width: 260,
      color: { dark: '#000000', light: '#FFFFFF' },
    })
      .then((url) => {
        if (!cancelled) setQrCodeUrl(url);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [extendTicketUrl]);

  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered className="expiredModal">
      <Modal.Body>
        <div className="expiredStamp">Expired</div>
        <h2 className="expiredModal__title">Your ticket is already expired</h2>
        <p className="expiredModal__copy">
          Please scan this QR code to extend your ticket and pay.
        </p>
        <div className="expiredModal__code">
          {qrCodeUrl ? <img src={qrCodeUrl} alt="Extend ticket QR code" /> : null}
        </div>
        <button type="button" className="expiredModal__cancel" onClick={onHide}>
          Cancel
        </button>
      </Modal.Body>
    </Modal>
  );
}

export default ExpiredModal;
